import { connect } from 'react-redux';
import ConversionBanner from './ConversionBanner';

const mapState = state => {
  const { subscriptions, userID } = state.fenderConnect;

  return {
    playSubscripton: subscriptions ? subscriptions.play : null,
    isAuthenticated: !!userID,
  };
};

export default connect(mapState)(ConversionBanner);
